import { supabase } from '@/lib/supabase';

function haversineDistance(lat1, lng1, lat2, lng2) {
  const R = 6371000; // mètres
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
    Math.sin(dLng/2) * Math.sin(dLng/2);
  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
}

export async function createCheckIn({ playground_id, user_lat, user_lng }) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) throw new Error('Non authentifié');

  const { data: playground } = await supabase
    .from('playgrounds')
    .select('coords_json')
    .eq('id', playground_id)
    .single();

  if (!playground?.coords_json) throw new Error('Terrain introuvable');

  const coords = typeof playground.coords_json === 'string'
    ? JSON.parse(playground.coords_json)
    : playground.coords_json;

  const distance_m = haversineDistance(user_lat, user_lng, coords.lat, coords.lng);
  const THRESHOLD_M = 80;
  const is_valid = distance_m <= THRESHOLD_M;

  const { data: checkin, error } = await supabase
    .from('check_ins')
    .insert({
      user_id: user.id,
      playground_id,
      user_coords_json: { lat: user_lat, lng: user_lng },
      distance_m,
      is_valid,
      checked_in_at: new Date().toISOString()
    })
    .select()
    .single();

  if (error) throw error;

  return {
    checkin_id: checkin.id,
    distance_m,
    is_valid,
    threshold_m: THRESHOLD_M
  };
}
